
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import cartServices from '@/services/cart-services';
import commonService from '@/services/common-services';
@Component({
    components: {
        Loading
    },
})
export default class DetailProduct extends Vue {
    private isLoading = false;
    private selectedProduct: any = null;
    private selectedQuantity: number = 1;
    private mainImage: string = '';
    private itemUrl: string = '';
    get rate() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }
    get currentPrice() {
        return this.getPriceByQuantity(this.selectedQuantity);
    }
    get currentPriceVND() {
        return (this.currentPrice * this.rate).toLocaleString();
    }
    get minPrice() {
        if (this.selectedProduct && this.selectedProduct.wholesales && this.selectedProduct.wholesales.length > 0) {
            return this.selectedProduct.wholesales[this.selectedProduct.wholesales.length - 1].price;
        }
        return this.selectedProduct.sellPrice;
    }
    get maxPrice() {
        return this.selectedProduct.sellPrice;
    }
    async created() {
        this.isLoading = true;
        if (!this.rate) {
            await this.getRate();
        }
        this.itemUrl = this.$route.query.itemUrl as string;
        if (this.itemUrl) {
            await this.loadProductDetail();
        }
        this.isLoading = false;
    }

    private async loadProductDetail() {
        const productDetail = await cartServices.detailProduct(this.itemUrl);
        if (productDetail && productDetail.status === 200) {
            if (productDetail.data.data.success) {
                this.selectedProduct = productDetail.data.data.content.sanPham;
                this.mainImage = this.selectedProduct.imgThumbs[0];
                // reset active
                this.selectedProduct.itemPropertys.forEach(itemProperty => {
                    itemProperty.childPropertys.forEach(childProperty => {
                        childProperty.isActive = false;
                    });
                });
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: productDetail.data.data.content,
                });
            }
        }
    }

    private changeMainImage(image) {
        this.mainImage = image;
    }

    private selectAttribute(itemProperty, childProperty) {
        const child = [...itemProperty.childPropertys];
        child.forEach(c => {
            if (c === childProperty) {
                c.isActive = true;
                this.mainImage = c.bigImage || this.mainImage;
            } else {
                c.isActive = false;
            }
        });
        itemProperty.childPropertys = child;
    }

    private getSelectedSku() {
        const selectedSku = [];
        this.selectedProduct.itemPropertys.forEach(itemProperty => {
            itemProperty.childPropertys.forEach(childProperty => {
                if (childProperty.isActive) {
                    selectedSku.push(childProperty.title);
                }
            });
        });
        return selectedSku;
    }

    private increaseQuantity() {
        this.selectedQuantity++;
        this.validateQuantity();
    }

    private decreaseQuantity() {
        if (this.selectedQuantity > 1) {
            this.selectedQuantity--;
        }
        this.validateQuantity();
    }
    private validateQuantity() {
        if (this.selectedQuantity < 1) {
            this.selectedQuantity = 1;
        }
    }

    private getSiteName(link) {
        if (!link) { return ''; }
        if (link.includes('1688')) { return '1688'; }
        if (link.includes('taobao')) { return 'TAOBAO'; }
        if (link.includes('tmall')) { return 'TMALL'; }
        return '';
    }

    private async getRate() {
        const result = await commonService.exchangeRate();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
            (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
        }
    }

    private getPriceByQuantity(quantity: number): number {
        if (this.selectedProduct && this.selectedProduct.wholesales && this.selectedProduct.wholesales.length > 0) {
            for (const wholesale of this.selectedProduct.wholesales) {
                if (quantity >= wholesale.begin && (wholesale.end === 0 || quantity <= wholesale.end)) {
                    return wholesale.price;
                }
            }
        }
        return this.selectedProduct.sellPrice;
    }

    private async addToCart() {
        const selectedSku = this.getSelectedSku();
        if (selectedSku.length < this.selectedProduct.itemPropertys.length) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Vui lòng chọn đầy đủ thuộc tính sản phẩm trước khi thêm vào giỏ hàng',
            });
            return;
        }
        const result = await cartServices.cartAddItem(
            {
                'ShopID': this.selectedProduct.shopId,
                'ShopName': this.selectedProduct.shopName,
                'Site': this.getSiteName(this.selectedProduct.itemUrl),
                'Note': '',
                'IsFragileGoods': 0,
                'IsFeeShip': 0,
                'Products': [
                    {
                        'item_id': this.selectedProduct.productId,
                        'shop_id': this.selectedProduct.shopId,
                        'shop_name': this.selectedProduct.shopName,
                        'title_origin': this.selectedProduct.name,
                        'image_origin': this.mainImage,
                        'link_origin': this.selectedProduct.itemUrl,
                        'property': selectedSku.join(';'),
                        'quantity': this.selectedQuantity,
                        'price_origin': this.currentPrice,
                        'price_promotion': this.currentPrice,
                        'comment': ''
                    }
                ]
            }
        );
        if (result && result.data.status === 200 && result.data.message === 'Success') {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Đã thêm sản phẩm vào giỏ hàng. Bạn hãy nhấn vào Giỏ hàng để lên đơn nhé.',
            });
        } else if (result && result.data.status === 202) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: result.data.error,
                duration: 5000
            });
            this.isLoading = false;
        } else {
            this.isLoading = false;
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình đặt hàng, vui lòng liên hệ quản trị!',
            });
        }
    }
}
